export enum UserRole {
  SUPER_ADMIN = 'SADMW',
  ADMIN_WGU = 'ADMW',
  CANDIDATE = 'CNT',
  CONSULTANT = 'CLT',
  CONSULTANT_EXTERN = 'CEX',
  INTERVENER = 'SAL',
  ADMIN_ESN = 'ESNAB',
  ESN_UNSUBSCRIBED = 'ESNNAB',
  CFIN = 'CFIN'
}